import { render, staticRenderFns } from "./auditionRecord.vue?vue&type=template&id=3ffa90d6"
import script from "./auditionRecord.vue?vue&type=script&lang=js"
export * from "./auditionRecord.vue?vue&type=script&lang=js"
import style0 from "./auditionRecord.vue?vue&type=style&index=0&id=3ffa90d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ffa90d6')) {
      api.createRecord('3ffa90d6', component.options)
    } else {
      api.reload('3ffa90d6', component.options)
    }
    module.hot.accept("./auditionRecord.vue?vue&type=template&id=3ffa90d6", function () {
      api.rerender('3ffa90d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/auditionManage/auditionRecord.vue"
export default component.exports